import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { CreateUserComponent } from 'src/app/shared/components/create-user/create-user.component';

@Component({
    selector: 'app-client-users',
    templateUrl: './client-users.component.html',
    styleUrl: './client-users.component.scss',
    standalone: false
})
export class ClientUsersComponent implements OnInit {

	@ViewChild('createUser') createUserModal!: CreateUserComponent;

	users: any[] = [];
  currentPage: number = 1;
  pageSize: number = 8;
  totalUsers: number = 0;
  searchText: string = '';
  sortColumn: string = 'first_name';
  sortDirection: string = 'desc';

	startIndex: number = 0;
  endIndex: number = 0;

	currentUser: any = null;
	loading = true;

	private searchSubject = new Subject<string>();

	constructor(private userService: UserService, private authService: AuthService) {}

	ngOnInit(): void {
		this.currentUser = this.authService.currentUserValue;
		this.getUsers();

    // Subscribe to search input changes with debounce
    this.searchSubject.pipe(
      debounceTime(300), // Adjust debounce time as needed
      distinctUntilChanged()
    ).subscribe(() => {
      this.currentPage = 1; // Reset to first page when search text changes
      this.getUsers();
    });
	}

	getUsers() {
		this.loading = true;
    const params = {
      page: this.currentPage.toString(),
      pageSize: this.pageSize.toString(),
      searchText: this.searchText,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection
    };

		this.userService.getClientUsers(params).subscribe({
			next: (response: any) => {
				this.users = response.users;
				this.totalUsers = response.totalUsers;
				this.calculateIndexes();
				this.loading = false;
			},
			error: (err) => {
				this.authService.toastErrorMessage(err.message ? err.message : err, 'Getting Users')
			}
		});
  }

	refreshUsers() {
		this.currentPage = 1;
		this.searchText = '';
		this.getUsers();
	}

	onPageChange(page: number) {
    this.currentPage = page;
    this.getUsers();
  }

  onSearch() {
    this.searchSubject.next(this.searchText);
  }

  onSort(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
		
    this.getUsers();
  }

	calculateIndexes() {
    this.startIndex = (this.currentPage - 1) * this.pageSize + 1;
    this.endIndex = Math.min(this.currentPage * this.pageSize, this.totalUsers);
  }

	openModal(mode: string, user?: any) {
		switch (mode) {
			case 'create':
				this.createUserModal.openModal('create');
				break;
			case 'invite':
				this.createUserModal.openModal('invite', user);
				break;
			case 'edit':
				this.createUserModal.openModal('edit', user);
				break;
			case 'remove':
				this.createUserModal.openModal('remove', user);
				break;
			case 'suspend':
				this.createUserModal.openModal('suspend', user);
				break;
			case 'activate':
				this.createUserModal.openModal('activate', user);
				break;
		}
	}
}
